export default (props) => (
  /**
   * Icone de uma seta apontando para nordeste com um quadrado faltando um pedaço
   * responsavel por exportar projeto.
   * Encontrado no menu de ferramentas.
  */
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0992 6.09029C11.3704 5.81903 11.9069 5.9157 12.2974 6.30623C12.688 6.69675 12.7846 7.23324 12.5134 7.50451L6.26177 13.7561C5.99051 14.0274 5.45402 13.9307 5.0635 13.5402C4.67297 13.1496 4.57629 12.6132 4.84756 12.3419L11.0992 6.09029Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M11.4966 7.10791L7.49658 7.10791C6.9443 7.10791 6.49658 6.66019 6.49658 6.10791C6.49658 5.55563 6.9443 5.10791 7.49658 5.10791L12.4966 5.10791C13.0489 5.10791 13.4966 5.55563 13.4966 6.10791L13.4966 11.1079C13.4966 11.6602 13.0489 12.1079 12.4966 12.1079C11.9443 12.1079 11.4966 11.6602 11.4966 11.1079L11.4966 7.10791Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M15.4082 9.46094C15.4082 8.90865 15.8559 8.46094 16.4082 8.46094C16.9605 8.46094 17.4082 8.90865 17.4082 9.46094V15.0859C17.4082 16.6738 16.121 17.9609 14.5332 17.9609H3.2832C1.69538 17.9609 0.408203 16.6738 0.408203 15.0859L0.408206 3.83593C0.408206 2.24812 1.69539 0.960938 3.2832 0.960938C7.31514 0.960941 7.31514 0.960941 9.37696 0.960941C9.92924 0.960941 10.377 1.40866 10.377 1.96094C10.377 2.51323 9.92924 2.96094 9.37696 2.96094C7.31514 2.96094 7.31514 2.96094 3.2832 2.96094C2.79995 2.96094 2.40821 3.35269 2.40821 3.83593L2.4082 15.0859C2.4082 15.5692 2.79995 15.9609 3.2832 15.9609H14.5332C15.0165 15.9609 15.4082 15.5692 15.4082 15.0859V9.46094Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
